import { CurrencyRateLabelTextHelper } from '../labelTextHelper/CurrencyRateLabelTextHelper';
import { HeaderItem } from '../../model/HeaderItem';

const excludedImportFieldList = ['currencyRateId', 'dateCreateAt', 'dateModifyAt'];

export const CurrencyRateHeaderHelper = {
    getHeaderItems(): HeaderItem[] {
        return [
            { text: CurrencyRateLabelTextHelper.getLabelText.currencyRateId, value: 'currencyRateId' },
            { text: CurrencyRateLabelTextHelper.getLabelText.currencyCodeFrom, value: 'currencyCodeFrom' },
            { text: CurrencyRateLabelTextHelper.getLabelText.currencyCodeTo, value: 'currencyCodeTo' },
            { text: CurrencyRateLabelTextHelper.getLabelText.exchangeRate, value: 'exchangeRate' },
            {
                text: CurrencyRateLabelTextHelper.getLabelText.dateEffectiveOn,
                value: 'dateEffectiveOn',
                format: 'date'
            },
            { text: CurrencyRateLabelTextHelper.getLabelText.dateCreateAt, value: 'dateCreateAt', format: 'datetime' },
            { text: CurrencyRateLabelTextHelper.getLabelText.dateModifyAt, value: 'dateModifyAt', format: 'datetime' }
        ];
    },

    getDateTimePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'datetime')
            .map((item) => item.value);
    },

    getDatePropertyList(): string[] {
        return this.getHeaderItems()
            .filter((item) => item.format === 'date')
            .map((item) => item.value);
    },

    getActionHeaderItem(): HeaderItem {
        return { text: CurrencyRateLabelTextHelper.getLabelText.action, value: 'action' };
    },

    getCsvHeader() {
        return [...this.getHeaderItems().map((item) => ({ key: item.value, text: item.text }))];
    },

    getHeaders() {
        return [...this.getHeaderItems(), this.getActionHeaderItem()];
    },

    getImportFields() {
        return this.getFilteredHeaderItems().reduce((acc, item) => {
            acc[item.value] = {
                required: false,
                label: item.text
            };
            return acc;
        }, {} as Record<string, { required: boolean; label: string }>);
    },

    getImportHeaders() {
        return this.getFilteredHeaderItems();
    },

    getFilteredHeaderItems() {
        return this.getHeaderItems().filter((header) => !excludedImportFieldList.includes(header.value));
    }
};
